import React from "react";
import { createRoot } from "react-dom/client"; 
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

// FIXED: Removed <React.StrictMode> wrapper to allow Router v5 to work
root.render(
    <App />
);